export const getImageData = (type, resource) => {
  if (resource) {
    return { description: type === 'image' ? 'Original' : getDescription(type), src: resource };
  }
  return {
    description: getDescription(type),
    src: `https://cdn140.picsart.com/${type.toLowerCase()}.png`,
  };
};

export const getDescription = type => {
  const words = type.split('_');
  return words.map(word => word[0].toUpperCase() + word.substring(1)).join(' ');
};
